import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, autorun, action } from 'mobx';
import Spinner from '../Spinner';
import DataTable from '../DataTable';

@inject('dataSourceStore', 'daqProcessorStore', 'daqLocationStore')
@observer
class DaqProcessorList extends Component {
  static propTypes = {
    route: PropTypes.shape().isRequired,
    // params: PropTypes.shape({
    //   id: PropTypes.string.isRequired,
    // }).isRequired,
  };

  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  @observable dataSource = {};


  dispose;
  componentWillMount() {
    const { params: { id }, dataSourceStore, daqProcessorStore, daqLocationStore } = this.props;
    if (!daqLocationStore.items.length) daqLocationStore.fetchItems();
    if (daqProcessorStore.items.length === 0) daqProcessorStore.fetchItems();
    if (dataSourceStore.items.length === 0) dataSourceStore.fetchItems();
    // if (id !== this.props.params.id) {
    //   this.dispose = autorun(() => {
    //     const foundDataSource = dataSourceStore.findById(id);
    //     if (foundDataSource) {
    //       this.resetInputValues(foundDataSource);
    //       this.dispose();
    //     }
    //   });
    // }
  }

  // componentWillReceiveProps(nextProps) {
  //   const { params: { id }, dataSourceStore } = nextProps;
  //   if (id !== this.props.params.id) {
  //     const dispose = autorun(() => {
  //       const foundDataSource = dataSourceStore.findById(id);
  //       if (foundDataSource) {
  //         this.resetInputValues(foundDataSource);
  //         // dispose();
  //       }
  //     });
  //   }
  // }

  @action resetInputValues(item) {
    if (!item) { return; }
    this.dataSource = item.asJson;
  }

  columns = [
    // { key: 'id', label: 'ID' },
    { key: 'parser', label: 'Parser' },
    // { key: 'data_source', label: 'Data Source' },
    { key: 'protocol_name', label: 'Protocol' },
  ];

  @action handleDelete = (idOrIds) => {
    const { notify } = this.context;
    console.log('handleDelete', idOrIds);
    this.props.daqProcessorStore.removeItems(idOrIds)
      .then(notify.success)
      .catch(notify.error);
  };

  render() {
    const {
      dataSourceStore,
      daqProcessorStore,
      params: { id },
    } = this.props;

    // const daqProcessors = this.dataSource.daq_processors || [];

    if (daqProcessorStore.isLoading || dataSourceStore.isLoading) return <Spinner />;

    let daqProcessors = daqProcessorStore.items.map(item => (Object.assign(item, { data_source: dataSourceStore.items.find(ds => +ds.id === +item.data_source_id) && dataSourceStore.items.find(ds => +ds.id === +item.data_source_id).name }, { protocol_name: daqProcessorStore.protocolOptions.find(p => +item.protocol === p.id) && daqProcessorStore.protocolOptions.find(p => +item.protocol === p.id).name })));

    return (
      <div>
        <DataTable
          data={daqProcessors}
          slug={`daq/daq-processor`}
          // parentSlug={`/daq/data-source/${id}`}
          columns={this.columns}
          onDelete={this.handleDelete}
          caption="DAQ Processors"
          allowAdd
          allowEdit
          allowDelete
          resource='daq-processor'
        />
        {this.props.children}
      </div>
    );
  }
}

export default DaqProcessorList;



// WEBPACK FOOTER //
// ./src/components/DataSource/DaqProcessorList.js